<template lang="pug">
div.tw-flex.tw-items-center(class="emd:tw-flex-col")
	v-autocomplete(
		:items="searchDepartureProps.filteredStations.value"
		v-model:search="searchDepartureProps.searchText.value"
		:loading="searchArrivalProps.loading.value"
		:rules="stationRules"
		v-model="bookingStore.searchFilters.departureStation"
		:label="$t('form_labels.stations_fields.departure', 'Da dove parti ?')"
		item-title="name"
		item-value="service_id"
		return-object
		hide-no-data
		no-filter
		clearable
		:disabled="(searchDepartureProps.loading.value || props.disabled)"
		open-on-clear
		@focus="selectAllText($event);"
		class="tw-basis-1/2 emd:tw-w-full station-field"
		:class="isMobile || showSwitch ? '' : 'start-field'"
		:menu-props="{'close-on-content-click': true, 'minWidth': '0px'}"
	)
		template(v-slot:prepend-inner)
			v-icon(icon="mdi-map-marker-outline" color="accent")
		template(v-slot:item="{props, item}")
			v-list-item(
				v-bind="props"
			)
				template(v-slot:title)
					span.tw-capitalize {{ item?.title.toLowerCase() }}
				template(v-slot:prepend)
					v-icon(icon="mdi-map-marker-outline" color="accent")

	v-btn(v-if="showSwitch" :icon="switchStationsButtonIcon" :class="isMobile ? 'custom-h-fit' : ''" variant="plain" color="accent" @click='switchStations')

	v-autocomplete(
		:items="searchArrivalProps.filteredStations.value"
		v-model:search="searchArrivalProps.searchText.value"
		:loading="searchArrivalProps.loading.value"
		:rules="stationRules"
		v-model="bookingStore.searchFilters.arrivalStation"
		:label="$t('form_labels.stations_fields.arrival', 'Dove vuoi andare ?')"
		item-title="name"
		item-value="service_id"
		return-object
		hide-no-data
		no-filter
		clearable
		:disabled="(searchDepartureProps.loading.value || props.disabled)"
		@focus="selectAllText($event);"
		class="tw-basis-1/2 emd:tw-w-full station-field"
		:class="isMobile || showSwitch ? '' : 'end-field'"
		:menu-props="{'close-on-content-click': true, 'minWidth': '0px'}"
	)
		template(v-slot:prepend-inner)
			v-icon(icon="mdi-map-marker-outline" color="accent")
		template(v-slot:item="{props, item}")
			v-list-item.tw-capitalize(
				v-bind="props"
			)
				template(v-slot:title)
					span.tw-capitalize {{ item?.title.toLowerCase() }}
				template(v-slot:prepend)
					v-icon(icon="mdi-map-marker-outline" color="accent")
</template>

<script setup>
import { useBookingStore } from '@/stores/booking';
import {inject, onMounted} from 'vue';
import {findStationByID, useSearchStation} from '@/composables/stations.js';
import { computed } from 'vue';


const bookingStore = useBookingStore();
const stationRules = [
	value => !!value || 'Required.'
];
const props = defineProps({
	disabled: Boolean,
	showSwitch: Boolean
});
const selectedDepartureStation = computed(() => bookingStore.searchFilters.departureStation);
const searchDepartureProps = useSearchStation({
	selectedStation: selectedDepartureStation
});
const selectedArrivalStation = computed(() => bookingStore.searchFilters.arrivalStation);
const searchArrivalProps = useSearchStation({
	selectedStation: selectedArrivalStation
});
const isMobile = inject('isMobile');
const switchStationsButtonIcon = computed(() => {
	if (isMobile.value) return 'mdi-swap-vertical';
	return 'mdi-swap-horizontal';
})


/**
 * Select all text after focus the input
 */
function selectAllText(event){
	if(event.target && typeof(event.target.select) == 'function'){
		setTimeout(() => event.target && typeof(event.target.select) == 'function' && event.target.select(), 100);
	}
}
function switchStations(){
	const swap = bookingStore.searchFilters.departureStation;
	bookingStore.searchFilters.departureStation = bookingStore.searchFilters.arrivalStation;
	bookingStore.searchFilters.arrivalStation = swap;
}


onMounted(() => {
	if (bookingStore.searchFilters.departureStation && !bookingStore.searchFilters.departureStation.name) {
		bookingStore.searchFilters.departureStation = findStationByID(bookingStore.searchFilters.departureStation.service_id || bookingStore.searchFilters.departureStation.id);
	}
	if (bookingStore.searchFilters.arrivalStation && !bookingStore.searchFilters.arrivalStation.name) {
		bookingStore.searchFilters.arrivalStation = findStationByID(bookingStore.searchFilters.arrivalStation.service_id || bookingStore.searchFilters.arrivalStation.id);
	}
});
</script>

<style scoped>
.start-field :deep(.v-field){
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	border-right: 0;
}
.end-field :deep(.v-field){
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}
.custom-h-fit {
	height: fit-content !important;
}
</style>